import { FieldArray } from "formik";
import * as React from "react";
import styled, { css } from "styled-components";

import {
  rgba,
  theme
} from "src/library/utils";

import Grid from "../Hedron";
import { IFormCheckbox } from ".";
import FieldError from "./FieldError";
import Label from "./Label";

const hexToRgba = rgba(theme.colors.primaryDark, 1);
const checkTick = `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 24 24' fill='${hexToRgba}' stroke='none'><path d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' /></svg>`;

export const CheckboxStyled = styled.input.attrs({ type: "checkbox" })`
  display: block;
  appearance: none;
  margin: 2px;
  width: 25px;
  height: 25px;
  background-color: ${({ theme }) => theme.colors.white};
  background-image: url("${checkTick}");
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 0% auto;
  border-radius: ${({ theme }) => theme.borderRadius};
  border: 2px solid ${({ theme }) => theme.colors.primaryDark};
  box-sizing: border-box;
  outline: none;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:checked {
    background-size: 100% auto;
  }

  &:hover:not(&:disabled) {
    cursor: pointer;
  }
`;

export const CheckboxLabel = styled(Label)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    padding-bottom: 0;
    margin-bottom: ${theme.spacing.padding.sm};

    span {
      padding-left: ${theme.spacing.padding.sm};
    }
  `}
`;

const Checkbox: React.ReactFCWithChildren<IFormCheckbox> = props => {
  return (
    <>
      <Grid.Box>
        <Label
          for={props.name}
          label={props.label}
          required={props.validation?._exclusive?.required}
        />
      </Grid.Box>

      <Grid.Box>
        <FieldArray
          name={props.name}
          render={arrayHelpers =>
            props.options.map((opt, index) => (
              <Grid.Bounds
                key={`${props.name}-${index}`}
                valign="top"
                direction="horizontal"
                style={{ position: "relative" }}
              >
                <Grid.Box>
                  <CheckboxLabel
                    className="checkbox-label"
                    for={`${props.name}-${index}`}
                    label={opt.text}
                  >
                    <CheckboxStyled
                      disabled={props.disabled}
                      onChange={e => {
                        if (!props.as) {
                          if (e.target.checked) {
                            arrayHelpers.push(opt.value);
                          } else {
                            if (typeof props.value !== "number") {
                              const idx = props.value.indexOf(opt.value.toString());

                              arrayHelpers.remove(idx);
                            }
                          }
                        }
                      }}
                      name={props.name}
                      id={`${props.name}-${index}`}
                      defaultChecked={opt.checked || false}
                    />
                  </CheckboxLabel>
                </Grid.Box>
              </Grid.Bounds>
            ))}
        />
      </Grid.Box>

      {props.error && (
        <Grid.Box>
          <FieldError>
            {props.error}
          </FieldError>
        </Grid.Box>
      )}
    </>
  );
};

export default Checkbox;
